import { cloneDeep } from 'lodash';
import generalTransformer from '@/services/general/transform';

function transformOrderByMapper(serverTableData) {
  const copy = cloneDeep(serverTableData);
  switch(copy.orderBy) {
    case 'produitFace.codePanneau':
      copy.orderBy = 'codePanneau';
      break;
    case 'tiers.nomCommercial':
      copy.orderBy = 'tiersNomCommercial';
      break;
    case 'produitFace.format':
      copy.orderBy = 'format';
      break;
    case 'produitFace.materielType':
      copy.orderBy = 'materielType';
      break;
    case 'produitFace.adresse.codePostal':
      copy.orderBy = 'codePostal';
      break;
    case 'produitFace.adresse.ville':
      copy.orderBy = 'ville';
      break;
    default:
      break;
  }
  return copy;
}

export default function transformer(serverTableData) {
  const inputServer = transformOrderByMapper(serverTableData);
  if (!inputServer.orderBy) {
    inputServer.ascending = 0;
    inputServer.orderBy = 'creationTime';
  }
  if (inputServer.query && inputServer.query.actif === undefined) {
    inputServer.query.actif = true;
  }
  return generalTransformer(inputServer);
}
